export type Orientation = 'landscape' | 'portrait';

export const LogLevel = {
    Trace: 'TRACE',
    Debug: 'DEBUG',
    Info: 'INFO',
    Warn: 'WARN',
    Error: 'ERROR'
} as const;

export type LogLevelType = keyof typeof LogLevel;
export type LogLevelValue = typeof LogLevel[keyof typeof LogLevel];

export interface ClientInfo {
    user_agent: string;
    viewport_height: number;
    viewport_width: number;
}
export interface LogOptions {
    message: string;
    stackTrace?: string;
}

export interface SessionInfo {
    user_language: string;
    orientation: Orientation;
    touch_capable: boolean;
    screen_width: number;
    screen_height: number;
}

export interface LogData extends ClientInfo {
    level: LogLevelValue;
    message: string;
    stack_trace: string;
    request_path: string;
    timestamp: number;
    timezone: number;
}

export interface SessionStatsData extends SessionInfo, ClientInfo {}

export type MetricType = 'counter' | 'gauge' | 'histogram' | 'summary';

export interface MetricData {
    name: string;
    type: MetricType;
    value: number;
}
